module.exports = __webpack_public_path__ + "img/template11.662136ec.png";